export default __webpack_public_path__ + "static/2-6a32ea8bba62727cde96cb6888f8d5b6.jpg";